// services
import { CAS } from "../../service/ChatConfig.Service";

//components
import { ProfileImage } from "thrive-components";

//interfaces
import { IContactInformationProps } from "../../interfaces";

//styling
import "../../styles/ContactInformation.scss";


const ContactInformation = ({profileImageUrl, displayName, jobRole, department}: IContactInformationProps) => {
    
    return (
        <div id="new-chat-contact-information">
            <div className="contact-information-image-wrapper">
                <ProfileImage 
                    className="contact-information-contact-image" 
                    profileImageUrl={profileImageUrl}
                    accessToken={CAS.getAccessToken() as string}
                />
            </div>

            <div className="contact-information">
                <span className='contact-information-name'>
                    {displayName}
                </span>

                <span className='contact-details'>
                    {jobRole}
                    {jobRole && department && ', '}
                    {department}
                </span>
            </div>
        </div>
    );
};

export default ContactInformation;